export default __webpack_public_path__ + "static/media/keycard-swisspass-back@4x.527e01a4.png";